import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';
import {
  array,
  number,
  object,
  string,
  rangeNumber,
  bool,
} from '@gogame/schemas';

import {
  FILTER_APPLICATIONS,
  FILTER_DESIGNERS,
  FILTER_CHANNELS,
  FILTER_COMMENTS,
  FILTER_CREATED_BY,
  FILTER_CREATIVE_TYPES,
  FILTER_ENHANCERS,
  FILTER_EXCLUDED_TAGS,
  FILTER_AI_TAGGING_STATUS,
  FILTER_GENRES,
  FILTER_INTERNAL_TAGS,
  FILTER_LANGUAGES,
  FILTER_MEDIA_TYPES,
  FILTER_NETWORKS,
  FILTER_ORIENTATIONS,
  FILTER_FILTER_BY,
  FILTER_OS,
  FILTER_EXCLUSIVE_FOR_AFFILIATES,
  FILTER_CREATIVES_ADDED,
  FILTER_CONCEPTS_ADDED,
  FILTER_START_PERIOD,
  FILTER_EXPIRATION_PERIOD,
  FILTER_REQUESTED_BY,
  FILTER_RESOLUTIONS,
  FILTER_SIZES,
  FILTER_STATUSES,
  FILTER_CONCEPT_FAMILIES,
  FILTER_USED_IN_ADS,
  FILTER_USED_IN_AFFILIATES,
  FILTER_LENGTHS,
  FILTER_BUSINESS_PARTNERS,
  FILTER_SHARED_WITH,
  FILTER_IS_NEW,
  FILTER_PROMO_CODES,
  FILTER_AI_TAGS,
  FILTER_RATIOS,
  FILTER_OUTSOURCE_STUDIOS,
  FILTER_INCLUDE_YT_LINK,
  FILTER_TESTED,
  FILTER_INVERT_AFFILIATE_FILTER,
  FILTER_AI_GENERATED,
  FILTER_PRODUCTION_TYPES,
} from 'scenes/Gallery/GalleryPage/constants';
import { EXPIRATION_PERIOD_PRESETS } from 'scenes/Gallery/GalleryPage/constants';

export const filtersSchema = object({
  [FILTER_CONCEPTS_ADDED]: array(string())
    .default(rangePresets.LAST_12_MONTHS_PLUS_TODAY.value)
    .constants(defaultRangePreset),
  [FILTER_CREATIVES_ADDED]: array(string()).constants(defaultRangePreset),
  [FILTER_EXPIRATION_PERIOD]: array(string()).constants(
    EXPIRATION_PERIOD_PRESETS
  ),
  [FILTER_START_PERIOD]: array(string()).constants(EXPIRATION_PERIOD_PRESETS),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_STATUSES]: array(number()),
  [FILTER_DESIGNERS]: array(number()),
  [FILTER_CREATIVE_TYPES]: array(number()),
  [FILTER_GENRES]: array(number()),
  [FILTER_LANGUAGES]: array(number()),
  [FILTER_MEDIA_TYPES]: array(number()),
  [FILTER_ORIENTATIONS]: array(number()),
  [FILTER_CREATED_BY]: array(number()),
  [FILTER_REQUESTED_BY]: array(number()),
  [FILTER_RESOLUTIONS]: array(number()),
  [FILTER_SIZES]: array(number()),
  [FILTER_PRODUCTION_TYPES]: array(number()),
  [FILTER_ENHANCERS]: array(number()),
  [FILTER_EXCLUSIVE_FOR_AFFILIATES]: array(number()),
  [FILTER_OS]: array(number()),
  [FILTER_CHANNELS]: array(number()),
  [FILTER_INTERNAL_TAGS]: array(number()),
  [FILTER_EXCLUDED_TAGS]: array(number()),
  [FILTER_AI_TAGGING_STATUS]: number(),
  [FILTER_COMMENTS]: number(),
  [FILTER_FILTER_BY]: number(),
  [FILTER_USED_IN_ADS]: number(),
  [FILTER_USED_IN_AFFILIATES]: array(number()),
  [FILTER_INVERT_AFFILIATE_FILTER]: bool(),
  [FILTER_IS_NEW]: number(),
  [FILTER_CONCEPT_FAMILIES]: array(number()),
  [FILTER_LENGTHS]: rangeNumber(FILTER_LENGTHS),
  [FILTER_BUSINESS_PARTNERS]: array(number()),
  [FILTER_SHARED_WITH]: array(number()),
  [FILTER_PROMO_CODES]: array(number()),
  [FILTER_AI_TAGS]: array(number()),
  [FILTER_RATIOS]: array(number()),
  [FILTER_OUTSOURCE_STUDIOS]: array(number()),
  [FILTER_INCLUDE_YT_LINK]: number(),
  [FILTER_TESTED]: array(number()),
  [FILTER_AI_GENERATED]: number(),
}).stripEmpty();

export const EMPTY_FILTERS = {
  ...filtersSchema.default(),
};
